import React from "react";
import { Plus, Trash2, Bold } from "lucide-react";

const SIZES = [
  { v: "small", label: "S", title: "Carattere piccolo" },
  { v: "normal", label: "M", title: "Carattere normale" },
  { v: "large", label: "G", title: "Carattere grande" },
];

/**
 * Editor righe formattate per intestazione/piè di pagina del preconto.
 * Ogni riga: testo libero + dimensione (S/M/G) + grassetto ON/OFF.
 */
export default function PrecontoLinesEditor({ label, lines = [], onChange, testid = "preconto-lines" }) {
  const update = (i, patch) => onChange((Array.isArray(lines) ? lines : []).map((l, j) => (j === i ? { ...l, ...patch } : l)));
  const remove = (i) => onChange((Array.isArray(lines) ? lines : []).filter((_, j) => j !== i));
  const add = () => onChange([...lines, { text: "", size: "normal", bold: false }]);

  return (
    <div>
      <label className="block text-xs font-mono uppercase tracking-widest text-velta-mute mb-2">{label}</label>
      <div className="space-y-1.5">
        {lines.length === 0 && (
          <div className="text-xs text-velta-subtle italic py-1">Nessuna riga. Aggiungine una qui sotto.</div>
        )}
        {(Array.isArray(lines) ? lines : []).map((l, i) => (
          <div key={i} className="flex items-center gap-1.5">
            <input
              data-testid={`${testid}-text-${i}`}
              value={l.text || ""}
              onChange={(e) => update(i, { text: e.target.value })}
              maxLength={42}
              placeholder="Testo riga…"
              className="h-9 flex-1 min-w-0 border border-velta-border rounded-md px-2 text-sm focus:outline-none focus:border-velta-ink"
            />
            <div className="flex rounded-md border border-velta-border overflow-hidden shrink-0">
              {(Array.isArray(SIZES) ? SIZES : []).map((s) => (
                <button
                  key={s.v}
                  type="button"
                  title={s.title}
                  data-testid={`${testid}-size-${s.v}-${i}`}
                  onClick={() => update(i, { size: s.v })}
                  className={`w-8 h-9 text-xs font-mono ${((l.size || "normal") === s.v) ? "bg-velta-ink text-white" : "bg-white text-velta-mute hover:text-velta-ink"}`}
                >
                  {s.label}
                </button>
              ))}
            </div>
            <button
              type="button"
              data-testid={`${testid}-bold-${i}`}
              onClick={() => update(i, { bold: !l.bold })}
              title="Grassetto"
              className={`w-9 h-9 shrink-0 rounded-md border flex items-center justify-center ${l.bold ? "bg-velta-ink text-white border-velta-ink" : "bg-white border-velta-border text-velta-mute hover:text-velta-ink"}`}
            >
              <Bold className="w-3.5 h-3.5" />
            </button>
            <button
              type="button"
              data-testid={`${testid}-del-${i}`}
              onClick={() => remove(i)}
              title="Rimuovi riga"
              className="w-9 h-9 shrink-0 rounded-md border border-velta-border text-velta-error hover:border-velta-error flex items-center justify-center"
            >
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        data-testid={`${testid}-add`}
        onClick={add}
        className="mt-2 h-9 px-3 border border-dashed border-velta-border hover:border-velta-ink rounded-md text-xs font-medium text-velta-mute hover:text-velta-ink flex items-center gap-1.5 btn-tactile"
      >
        <Plus className="w-3.5 h-3.5" /> Aggiungi riga
      </button>
    </div>
  );
}

/** Anteprima in stile scontrino delle righe formattate (usata anche da ScontrinoPreview). */
export function StyledReceiptLines({ lines = [], testid }) {
  return (
    <div className="text-center" data-testid={testid}>
      {(Array.isArray(lines) ? lines : []).map((l, i) => (
        <div
          key={i}
          className={`${(l.size || "normal") === "large" ? "text-[15px]" : l.size === "small" ? "text-[9px]" : "text-[11px]"} ${l.bold ? "font-bold" : ""} whitespace-pre-line leading-snug`}
        >
          {l.text || "\u00A0"}
        </div>
      ))}
    </div>
  );
}
